import axios from 'axios';
import Cookies from 'js-cookie'
import signature  from '@/services/signature';
import { useLicenseStore } from '@/stores/license.store';
const BASE_URL = process.env.VUE_APP_API_BASE_URI;

class AuthService {
  async login(user) {
    let data = {
      username: user.username,
      password: user.password,
      remember: user.remember
    }
    return await axios.post(BASE_URL + '/v1/auth/login' + signature(), data).then(response => {
      if (response.data.data.token) {
        Cookies.set('token', response.data.data.token, user.remember? {  expires : 365  }: '');
      }
      // license มาเป็นคีย์ระดับบนคู่กับ data (->additional ฝั่ง BE) ไม่ได้อยู่ใน data
      // ก้อนนี้ครบกว่า header (มี locked_on / server_time) และมาถึงตั้งแต่วินาทีแรกที่เข้าระบบ
      useLicenseStore().applyPayload(response.data.license);
      return response.data.data;
    });
  }
  logout() {
    Cookies.remove('token');
  }
}

export default new AuthService()
